import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { updateLatestActions, sendBugEmails } from "../utils";
import { FounderNote, Modal, BugTab, Loading } from "@peterfosso/prairi-components";
import { getFunctions, httpsCallable } from "firebase/functions"
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import {
  collection,
  db,
  getDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  Timestamp,
  addDoc,
} from "../firebase/firebaseApp";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseApp";
import { getAnalytics, logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebaseApp";

function Success() {
  const [openModal, setOpenModal] = useState(true);
  const [currentUserData, setCurrentUserData] = useState({});
   const [screenshotUrl, setScreenshotUrl] = useState(""); //for bug report
    const [bugEmail, setBugEmail] = useState("");
    const [bugText, setBugText] = useState(null);
      const [bugError, setBugError] = useState(null)
  
  const [userRef, setUserRef] = useState({});
  let { docId } = useParams();
  let navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentUserData, docId]);

  // Call updatePaymentPending function when component mounts
  useEffect(() => {
    const updatePaymentStatus = async () => {
      if (docId) {
        try {
          const functions = getFunctions();
          const updatePaymentPendingFn = httpsCallable(functions, "updatePaymentPending");
          
          const result = await updatePaymentPendingFn({
            userId: docId
          });
          
          console.log("Payment pending status updated successfully:", result.data);
          
          // Also update the local document for consistency
          const docRef = doc(db, "users", docId);
          await updateDoc(docRef, { paymentPending: false });
          
        } catch (error) {
          console.error("Error updating payment pending status:", error);
        }
      }
    };

    updatePaymentStatus();
    setTimeout(() => {
      navigate(`/createpassword/${docId}`);
    }, 2000);
  }, [docId]);

  const handleOKButtonClick = () => {
    setOpenModal(false);
    navigate("/");
  };
 const handleUpload = (e) => {
        return new Promise((resolve, reject) => {
          const selectedFile = e.target.files[0];
    
          const storageRef = ref(storage, `bugs/${selectedFile.name}`);
          const uploadTask = uploadBytesResumable(storageRef, selectedFile);
    
          uploadTask.on(
            "state_changed",
            null, // Manejador de progreso (puedes dejarlo como `null` si no necesitas reportarlo)
            (error) => { // Manejador de error
              console.error("Upload failed:", error);
              reject(error);
            },
            async () => { // Manejador de éxito
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(downloadURL);
              console.log("uploaded correctly");
              setScreenshotUrl(downloadURL);
            }
          );
          
        });
      };
    
      const handleBugText = (e) => {
        const value = e.target.value;
        setBugText(value);
        if (value !== "") {
          setBugError("");
        }
      };
      
      const handleBugEmail = (e) => {
        const value = e.target.value;
        setBugEmail(value);
        if (value !== "") {
          setBugError("");
        }
      };
      
      const validateFields = () => {
        if (!bugText || bugText.trim() === "") {
          setBugError("Please describe the bug.");
          return false;
        }
        if (!bugEmail || bugEmail.trim() === "") {
          setBugError("We need your email address.");
          return false;
        }
        return true;
      };
      
    const handleUploadAndSendEmail = async (file) => {
      try {
        if (!validateFields()) return;
  
        let uploadedUrl = screenshotUrl;
        if (file) {
          uploadedUrl = await handleUpload({ target: { files: [file] } });
        }
  
        console.log(`screenshotUrl ${uploadedUrl}`);
        sendBugEmails(bugEmail, "", bugText, "Build", uploadedUrl || "");
      } catch (error) {
        console.error("Error uploading file or sending email:", error);
      }
    };

  useEffect(() => {
    const getDataFromDb = async () => {
      try {
        // Call the Cloud Function instead of direct Firestore access
        const functions = getFunctions();
        const getUserDataFn = httpsCallable(functions, 'getUserData');
        
        const result = await getUserDataFn({ userId: docId });
        
        const { userData } = result.data;
        
        if (userData) {
          setCurrentUserData(userData);  // <- aún necesario si lo usas en otros lados
    
          // Aquí sí tienes la data y puedes hacer el log correctamente
          logEvent(analytics, "purchase", {
            currency: "USD",
            value:
              userData.category === "investor"
                ? userData.status === "yearly"
                  ? 900
                  : 1200
                : userData.status === "yearly"
                ? 99
                : 149,
            transaction_id: docId,
            items: [
              {
                item_id:
                  userData.category === "investor"
                    ? "investor_membership"
                    : "startup_membership",
                item_name: `${userData.category} membership`,
                price:
                  userData.category === "investor"
                    ? userData.status === "yearly"
                      ? 900
                      : 1200
                    : userData.status === "yearly"
                    ? 99
                    : 149,
                item_category: userData.category,
                item_variant: userData.status || "lifetime",
              },
            ],
          });
        } else {
          console.log("No such document!");
        }
        
        return { userData, userId: docId };
      } catch (error) {
        console.log(error);
      }
    };

    if (docId) {
      getDataFromDb();
    }
  }, [docId]);

  return (
    <div className="flex p-8 items-center justify-between text-base md:text-lg">
        <Modal
        open={openModal}
        transparent
        size="xl"
      >
            <BugTab
                      email={bugEmail}
                      
                      setEmail={handleBugEmail}
                      setText={handleBugText}
                      submit={(file) =>
                        handleUploadAndSendEmail(file)
                      }
                      error={bugError}
                      handleFileChange={handleUpload}
                    />
        <div className="text-center">
        <Loading/>
        </div>


      </Modal>
      </div>
  );
}

export default Success;
